import {useStyles} from '../../../../../shared/hooks/styles';

export const useCollapseStyles = () => {
  return useStyles(({theme}) => ({
    historyItem: {
      marginTop: 0,
      shadowColor: '#0000001A',
      shadowOffset: {
        width: 0,
        height: 2,
      },
      shadowRadius: 18,
      alignItems: 'flex-start',
      borderRadius: 14,
      backgroundColor: theme.color.backgroundMenuColor,
      elevation: 5,
    },

    collapseHeader: {
      width: '100%',
      paddingHorizontal: 24,
      paddingVertical: 26,
    },

    collapseBody: {
      width: '100%',
    },

    icon: {
      marginRight: 16,
      color: theme.color.primaryColor,
      justifyContent: 'center',
      height: 30,
    },

    text: {
      ...theme.fonts.h3,
      paddingHorizontal: 16,
    },

    colorPrimary: {
      color: theme.color.primaryColor,
    },
  }));
};
